import { useState } from 'react';
import api from '../services/api';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError('');

    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      setError('Please fill in all fields.');
      setLoading(false);
      return;
    }

    try {
      const res = await api.post('/contact', formData);

      if (res.data.success) {
        setSuccess(true);
        setFormData({ name: '', email: '', message: '' });
      } else {
        throw new Error(res.data.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="bg-gradient-to-r from-primary to-primary-600 text-white py-20 text-center">
        <div className="container">
          <h1 className="text-5xl font-bold mb-4">Contact Us</h1>
          <p className="text-xl max-w-2xl mx-auto">Get in touch with our admissions team</p>
        </div>
      </section>

      <section className="py-24">
        <div className="container">
          <div className="grid lg:grid-cols-2 gap-16">
            <div>
              <h2 className="text-4xl font-bold mb-8">Send us a Message</h2>

              {success && (
                <div className="mb-6 p-4 bg-green-100 text-green-800 rounded-2xl border border-green-200">
                  ✅ Your message has been sent successfully!
                </div>
              )}

              {error && (
                <div className="mb-6 p-4 bg-red-100 text-red-800 rounded-2xl border border-red-200">
                  ⚠️ {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-lg font-semibold mb-3">Full Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control w-full px-5 py-4 rounded-2xl border-2 border-slate-200 focus:border-primary focus:ring-4 focus:ring-primary/10 transition-all"
                    placeholder="Your name"
                    required
                  />
                </div>
                <div>
                  <label className="block text-lg font-semibold mb-3">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control w-full px-5 py-4 rounded-2xl border-2 border-slate-200 focus:border-primary focus:ring-4 focus:ring-primary/10 transition-all"
                    placeholder="your@email.com"
                    required
                  />
                </div>
                <div>
                  <label className="block text-lg font-semibold mb-3">Message</label>
                  <textarea
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control w-full px-5 py-4 rounded-2xl border-2 border-slate-200 focus:border-primary focus:ring-4 focus:ring-primary/10 transition-all resize-vertical"
                    placeholder="Tell us more about your inquiry..."
                    required
                  ></textarea>
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-primary w-full py-5 text-xl font-bold rounded-2xl shadow-xl hover:shadow-2xl transition-all disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {loading ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>

            <div className="space-y-8">
              <div className="bg-slate-50 rounded-3xl p-10">
                <h3 className="text-2xl font-bold mb-6">Visit Us</h3>
                <div className="flex items-start gap-4 mb-6">
                  <i className="fas fa-map-marker-alt text-3xl text-primary mt-1"></i>
                  <div>
                    <p>123 Islamic Street</p>
                    <p>Lagos, Nigeria</p>
                  </div>
                </div>
              </div>
              <div className="bg-slate-50 rounded-3xl p-10">
                <h3 className="text-2xl font-bold mb-6">Call Us</h3>
                <div className="flex items-start gap-4">
                  <i className="fas fa-phone text-3xl text-primary mt-1"></i>
                  <div>
                    <p>+234 123 456 7890</p>
                  </div>
                </div>
              </div>
              <div className="bg-slate-50 rounded-3xl p-10">
                <h3 className="text-2xl font-bold mb-6">Email</h3>
                <div className="flex items-start gap-4">
                  <i className="fas fa-envelope text-3xl text-primary mt-1"></i>
                  <div>
                    <p>info@islamicschool.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
